import Vue from "vue";
import VueCookies from "vue-cookies";
import VueHead from "vue-head";
import VueRouter from "vue-router";
import Home from "./Home.vue";
import App from "./App.vue";
import AppSzukaj from "./AppSzukaj.vue";
import AppHotel from "./AppHotel.vue";
import AppPortaleTurystyczne from "./AppPortaleTurystyczne.vue";
import AppPrzewodnikTurystyczny from "./AppPrzewodnikTurystyczny.vue";
import AppMapaSerwisu from "./AppMapaSerwisu.vue";
import AppInformacje from "./AppInformacje.vue";
import T1ONas from "./views/T1ONas";
import T1Kontakt from "./views/T1Kontakt";
import T1Regulamin from "./views/T1Regulamin";
import T1PolitykaPrywatnosci from "./views/T1PolitykaPrywatnosci";
import * as CONFIG from "./components/config.js";
import VueSplide from "@splidejs/vue-splide";
import "@splidejs/splide/dist/css/splide.min.css";
import T1Spinner from "./components/T1Shared/T1Spinner";
import "./scss/common-styles.scss";

import "vue-global-var";
import {
  Affix,
  Anchor,
  AutoComplete,
  Alert,
  // Avatar,
  BackTop,
  // Badge,
  // Breadcrumb,
  Button,
  Calendar,
  Card,
  Collapse,
  // Carousel,
  Cascader,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Dropdown,
  Form,
  Icon,
  Input,
  InputNumber,
  Layout,
  List,
  LocaleProvider,
  message,
  Menu,
  Modal,
  notification,
  Pagination,
  Popconfirm,
  Popover,
  // Progress,
  Radio,
  Rate,
  Row,
  Select,
  Slider,
  Spin,
  // Steps,
  Switch,
  Table,
  // Transfer,
  // Tree,
  // TreeSelect,
  // Tabs,
  Tag,
  TimePicker,
  // Timeline,
  Tooltip,
  // Mention,
  Upload,
  // version,
  Drawer,
  Skeleton,
  Comment,
  ConfigProvider,
} from "ant-design-vue";

Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
Vue.prototype.$info = Modal.info;
Vue.prototype.$success = Modal.success;
Vue.prototype.$error = Modal.error;
Vue.prototype.$warning = Modal.warning;
Vue.prototype.$confirm = Modal.confirm;

Vue.use(VueCookies);

/* v1.1.3+ registration methods */
Vue.use(Affix);
Vue.use(Anchor);
Vue.use(AutoComplete);
Vue.use(Alert);
// Vue.use(Avatar);
Vue.use(BackTop);
// Vue.use(Badge);
// Vue.use(Breadcrumb);
Vue.use(Button);
Vue.use(Calendar);
Vue.use(Card);
Vue.use(Collapse);
// Vue.use(Carousel);
Vue.use(Cascader);
Vue.use(Checkbox);
Vue.use(Col);
Vue.use(DatePicker);
Vue.use(Divider);
Vue.use(Drawer);
Vue.use(Dropdown);
Vue.use(Form);
Vue.use(Icon);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Layout);
Vue.use(List);
Vue.use(LocaleProvider);
Vue.use(Menu);
Vue.use(Modal);
Vue.use(Pagination);
Vue.use(Popconfirm);
Vue.use(Popover);
// Vue.use(Progress);
Vue.use(Radio);
Vue.use(Rate);
Vue.use(Row);
Vue.use(Select);
Vue.use(Slider);
Vue.use(Spin);
// Vue.use(Steps);
Vue.use(Switch);
Vue.use(Table);
// Vue.use(Transfer);
// Vue.use(Tree);
// Vue.use(TreeSelect);
// Vue.use(Tabs);
Vue.use(Tag);
Vue.use(TimePicker);
// Vue.use(Timeline);
Vue.use(Tooltip);
Vue.use(Upload);
Vue.use(Skeleton);
Vue.use(Comment);
Vue.use(ConfigProvider);
Vue.use(VueHead);
Vue.use(VueRouter);
Vue.use(VueSplide);
Vue.component("loading-spinner", T1Spinner);

Vue.config.productionTip = false;
//Vue.http.options.emulateJSON = true

const routes = [
  { path: "/", component: App },
  { path: "/**/**.xml", component: AppSzukaj },
  { path: "/rodzaj-oferty.xml", component: App },
  { path: "/portale-turystyczne.xml", component: AppPortaleTurystyczne },
  { path: "/mapa-serwisu.xml", component: AppMapaSerwisu },
  {
    path: "/informacje",
    redirect: "/o-nas",
    component: AppInformacje,
    children: [
      {
        path: "/o-nas",
        name: "O nas",
        component: T1ONas,
      },
      {
        path: "/kontakt",
        name: "Kontakt",
        component: T1Kontakt,
      },
      {
        path: "/regulamin",
        name: "Regulamin",
        component: T1Regulamin,
      },
      {
        path: "/polityka-prywatnosci",
        name: "Polityka prywatności",
        component: T1PolitykaPrywatnosci,
      },
    ],
  },
];

export const router = new VueRouter({
  mode: "history",
  routes, // short for `routes: routes`
});

window.$ = window.jQuery = window.jquery = require("jquery");

// env config in separate config.js file
//export const API_URL = 'http://localhost:8181/rest/vue2api';

var vm = new Vue({
  render: (h) => h(Home),
  router,
  components: {
    "a-layout-header": Layout.Header,
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-layout-content": Layout.Content,
    // "a-breadcrumb": Breadcrumb,
    // "a-breadcrumb-item": Breadcrumb.Item,
    "a-layout-footer": Layout.Footer,
  },
}).$mount("#app");
